//Adding aria-label on the price slider on the collection pages
document.addEventListener("DOMContentLoaded", function () {
  // The range inputs are built by JS (and rebuilt when filters change), so a
  // one-off timeout can miss them. Label them whenever they appear.
  function labelPriceSliders() {
    document.querySelectorAll("[data-js-price-range-slider]").forEach(function (slider) {
      const inputs = slider.querySelectorAll('input[type="range"]');
      const labels = ["Minimum price", "Maximum price"];

      inputs.forEach(function (input, i) {
        if (labels[i] && !input.hasAttribute("aria-label")) {
          input.setAttribute("aria-label", labels[i]);
        }
      });
    });
  }

  labelPriceSliders();
  new MutationObserver(labelPriceSliders).observe(document.body, { childList: true, subtree: true });

// Remove aria-labelledby from Swym tab containers
  function removeSwymAriaLabelledby() {
    document
      .querySelectorAll(".swym-storefront-layout-tab-container")
      .forEach(function (element) {
        element.removeAttribute("aria-labelledby");
      });
  }

  // Run once immediately
  removeSwymAriaLabelledby();

  // Watch for Swym dynamic rendering
  const observer = new MutationObserver(function () {
    removeSwymAriaLabelledby();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["aria-labelledby"]
  });

});

// Add to Cart
document.addEventListener('DOMContentLoaded', function () {
  const DRAWER_SELECTOR = '#site-cart-sidebar';
  const OPEN_BUTTON_SELECTOR = '.sidebar__cart-handle';
  const CLOSE_BUTTON_SELECTOR = '[data-js-close]';

  let lastFocusedElement = null;

  function getCartDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function focusCartDrawer() {
    const drawer = getCartDrawer();

    if (!drawer) return;

    let attempts = 0;

    const waitForDrawer = setInterval(function () {
      attempts++;

      const isOpen = drawer.classList.contains('opened');

      if (isOpen) {
        clearInterval(waitForDrawer);

        setTimeout(function () {
          drawer.focus({
            preventScroll: true
          });
        }, 100);
      }

      if (attempts >= 20) {
        clearInterval(waitForDrawer);
      }
    }, 50);
  }

  function restoreFocus() {
    if (
      lastFocusedElement &&
      lastFocusedElement.isConnected &&
      typeof lastFocusedElement.focus === 'function'
    ) {
      setTimeout(function () {
        lastFocusedElement.focus({
          preventScroll: true
        });

        lastFocusedElement = null;
      }, 100);
    }
  }

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest(OPEN_BUTTON_SELECTOR);

    if (!openButton) return;

    lastFocusedElement = openButton;

    focusCartDrawer();
  }, true);

  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest(CLOSE_BUTTON_SELECTOR);

    if (!closeButton) return;

    const drawer = getCartDrawer();

    if (!drawer) return;

    let attempts = 0;

    const waitForClose = setInterval(function () {
      attempts++;

      if (!drawer.classList.contains('opened')) {
        clearInterval(waitForClose);

        restoreFocus();
      }

      if (attempts >= 20) {
        clearInterval(waitForClose);
      }
    }, 50);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const drawer = getCartDrawer();

    if (!drawer) return;

    if (!drawer.classList.contains('opened')) return;

    const closeButton =
      drawer.querySelector(CLOSE_BUTTON_SELECTOR);

    if (!closeButton) return;

    event.preventDefault();

    closeButton.click();

    let attempts = 0;

    const waitForClose = setInterval(function () {
      attempts++;

      if (!drawer.classList.contains('opened')) {
        clearInterval(waitForClose);

        restoreFocus();
      }

      if (attempts >= 20) {
        clearInterval(waitForClose);
      }
    }, 50);
  });
});

// Heading replace
document.querySelectorAll('h4.footer-item__title.h4').forEach((h4) => {
  const h2 = document.createElement('h2');

  h2.innerHTML = h4.innerHTML;
  h2.className = h4.className;

  h4.replaceWith(h2);
});


// External links Warning 
document.addEventListener("DOMContentLoaded", function () {
  const excludedLinks = [
    'https://www.facebook.com/RosadosBox.LovePromiseJewelers/',
    'https://twitter.com/rosadosbox',
    'https://instagram.com/rosadosbox/',
    'https://www.pinterest.com/rosadosbox/',
    'https://www.youtube.com/channel/UCTAL_uAbH5dPN1cLxD9bJxQ/videos',
    'https://www.tiktok.com/@rosadosbox?lang=en',
  ];

  const normalizeHost = (host) => host.replace(/^www\./, '');

  const isExternalLink = (url) => {
    try {
      const linkUrl = new URL(url, window.location.origin); // handles relative URLs
      const linkHost = normalizeHost(linkUrl.hostname);
      const currentHost = normalizeHost(window.location.hostname);

      return linkHost && linkHost !== currentHost;
    } catch {
      return false;
    }
  };

  const enhanceExternalLinks = () => {
    const links = document.querySelectorAll('a');

    links.forEach(link => {
      const href = link.getAttribute('href');

      if (
        !href ||
        excludedLinks.includes(href) ||
        link.matches('li[data-submenu-parent] > a') ||
        !isExternalLink(href)
      ) return;

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      const linkText = link.textContent.trim();

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute(
          'aria-label',
          `${linkText}, Redirecting to a third-party website (opens in a new tab).`
        );
      }

      const img = link.querySelector('img, svg');
      if (img) {
        const altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, Redirecting to a third-party website (opens in a new tab).`
          : 'Redirecting to a third-party website (opens in a new tab).';

        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  const enhanceContactLinks = () => {
    const contactLinks = document.querySelectorAll(
      'a[href^="mailto:"], a[href^="tel:"]'
    );

    contactLinks.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  enhanceExternalLinks();
  enhanceContactLinks();
});

// Menu accessibility
// (function(){

// function initAccessibleSidebarDropdown(){

// 	const sidebar=document.querySelector("main-sidebar");

// 	if(!sidebar)return;

// 	const menuLinks=document.querySelectorAll(
// 		".sidebar__menu .has-first-submenu > a"
// 	);

// 	if(!menuLinks.length)return;


// 	menuLinks.forEach((link)=>{

// 		const parent=link.closest(".has-first-submenu");

// 		if(!parent)return;


// 		link.setAttribute("role","button");
// 		link.setAttribute("tabindex","0");
// 		link.setAttribute("aria-haspopup","true");
// 		link.setAttribute("aria-expanded","false");


// 		if(window.innerWidth>948){
// 			link.removeAttribute("href");
// 		}


// 		const openMenu=()=>{

// 			menuLinks.forEach(item=>{

// 				if(item!==link){
// 					item.classList.remove("selected");
// 					item.setAttribute("aria-expanded","false");
// 				}

// 			});


// 			link.classList.add("selected");
// 			link.setAttribute("aria-expanded","true");


// 			if(window.innerWidth>948 && sidebar.onMouseEnterHandlerFirst){

// 				sidebar.onMouseEnterHandlerFirst({
// 					currentTarget:parent,
// 					preventDefault:function(){}
// 				});

// 			}

// 		};


// 		const closeMenu=()=>{

// 			link.classList.remove("selected");
// 			link.setAttribute("aria-expanded","false");


// 			if(sidebar.onMouseLeaveHandlerFirst){

// 				sidebar.onMouseLeaveHandlerFirst();

// 			}

// 		};


// 		link.addEventListener("click",(e)=>{

// 			if(window.innerWidth>948){

// 				e.preventDefault();
// 				e.stopPropagation();


// 				if(
// 					link.getAttribute("aria-expanded")==="true"
// 				){

// 					closeMenu();

// 				}else{

// 					openMenu();

// 				}

// 			}

// 		});


// 		link.addEventListener("keydown",(e)=>{

// 			if(
// 				e.key==="Enter" ||
// 				e.key===" "
// 			){

// 				e.preventDefault();
// 				link.click();

// 			}


// 			if(e.key==="Escape"){

// 				closeMenu();
// 				link.focus();

// 			}

// 		});


// 	});


// 	document.addEventListener("click",(e)=>{

// 		if(
// 			window.innerWidth>948 &&
// 			!e.target.closest(".has-first-submenu")
// 		){

// 			menuLinks.forEach(link=>{

// 				link.classList.remove("selected");
// 				link.setAttribute(
// 					"aria-expanded",
// 					"false"
// 				);

// 			});


// 			if(sidebar.onMouseLeaveHandlerFirst){

// 				sidebar.onMouseLeaveHandlerFirst();

// 			}

// 		}

// 	});

// }


// if(document.readyState==="loading"){

// 	document.addEventListener(
// 		"DOMContentLoaded",
// 		initAccessibleSidebarDropdown
// 	);

// }else{

// 	initAccessibleSidebarDropdown();

// }

// })();

// document.addEventListener("DOMContentLoaded",function(){

// 	let lastMenuTrigger=null;

// 	document.querySelectorAll(
// 		".has-first-submenu > a"
// 	).forEach(function(button){

// 		button.addEventListener("click",function(){

// 			lastMenuTrigger=button;

// 			setTimeout(function(){

// 				const submenu=document.querySelector(
// 					".sidebar__seconds.sidebar-parent-element"
// 				);

// 				if(submenu){

// 					submenu.setAttribute(
// 						"tabindex",
// 						"-1"
// 					);

// 					submenu.focus({
// 						preventScroll:true
// 					});

// 				}

// 			},500);

// 		});

// 	});


// 	document.addEventListener("click",function(e){

// 		if(
// 			e.target.closest(".closemenu")
// 		){

// 			setTimeout(function(){

// 				if(lastMenuTrigger){

// 					lastMenuTrigger.focus();

// 				}

// 			},300);

// 		}

// 	});

// });

// Heading converting
document.addEventListener("DOMContentLoaded",function(){

	document.querySelectorAll("h3.text-w-icon__title.h2").forEach(function(element){

		const h2=document.createElement("h2");

		[...element.attributes].forEach(function(attr){
			h2.setAttribute(attr.name,attr.value);
		});

		h2.innerHTML=element.innerHTML;

		element.replaceWith(h2);

	});

});

// Add to cart focus
document.addEventListener("DOMContentLoaded",function(){

	let addToCartButtons=document.querySelectorAll(
		"button.product__add-to-cart.button"
	);

	if(!addToCartButtons.length)return;

	addToCartButtons.forEach(function(button){

		button.addEventListener("click",function(){

			const checkCartDrawer=setInterval(function(){

				const cartDrawer=document.querySelector(
					"sidebar-drawer#site-cart-sidebar"
				);

				if(
					cartDrawer &&
					cartDrawer.classList.contains("opened")
				){

					clearInterval(checkCartDrawer);

					cartDrawer.setAttribute(
						"tabindex",
						"-1"
					);

					cartDrawer.focus({
						preventScroll:true
					});

				}

			},100);


			setTimeout(function(){

				clearInterval(checkCartDrawer);

			},5000);

		});

	});

});

//Convert the h3 into h2 in the contact us page
document.addEventListener("DOMContentLoaded",function(){

	document.querySelectorAll(
		".content-section.gutter--on h3.h1"
	).forEach(function(element){

		const h2=document.createElement("h2");

		[...element.attributes].forEach(function(attr){
			h2.setAttribute(attr.name,attr.value);
		});

		h2.innerHTML=element.innerHTML;

		element.replaceWith(h2);

	});

});
// "Show more" description trigger is an <a> without href, so aria-expanded is
// not allowed on it. It acts as a button - give it that role (it is created by JS).
document.addEventListener("DOMContentLoaded", function () {
	function fixTruncatedTrigger() {
		document.querySelectorAll(".truncated__trigger:not([role])").forEach(function (el) {
			el.setAttribute("role", "button");
		});
	}

	fixTruncatedTrigger();
	new MutationObserver(fixTruncatedTrigger).observe(document.body, { childList: true, subtree: true });
});

// Header (mobile): menu, search and cart controls + hide closed drawers from screen readers
(function () {
	const MOBILE = window.matchMedia("(max-width: 948px)");

	// [handle, drawer, drawer id, handle label, dialog label, close label, only off-canvas on mobile]
	const PANELS = [
		[".sidebar__menu-handle", ".sidebar__menus", "SidebarMenuDrawer", "Menu", "Menu", "Close menu", true],
		[".sidebar__search-handle", ".sidebar__search", "SidebarSearchDrawer", "Search", "Search", "Close search", true],
		[".sidebar__cart-handle", ".sidebar__cart", "site-cart-sidebar", null, "Shopping Cart", "Close cart", false]
	];

	// spans with tabindex="0" that act as buttons only react to clicks - make Enter/Space work too
	function makeButton(el, label) {
		if (!el) return;
		if (el.tagName !== "BUTTON") el.setAttribute("role", "button");
		if (label) el.setAttribute("aria-label", label);
		if (el.dataset.a11yKeys) return;
		el.dataset.a11yKeys = "true";
		el.addEventListener("keydown", function (e) {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault();
				el.click();
			}
		});
	}

	function updateCartLabel(handle) {
		const count = handle.querySelector("[data-header-cart-count]");
		const n = count ? parseInt(count.textContent, 10) || 0 : 0;
		handle.setAttribute("aria-label", "Shopping Cart, " + n + (n === 1 ? " item" : " items"));
	}

	function init() {
		if (!document.querySelector("main-sidebar")) return;

		makeButton(document.querySelector(".announcement__exit"), "Close announcement");

		PANELS.forEach(function (cfg) {
			const handle = document.querySelector(cfg[0]);
			const drawer = document.querySelector(cfg[1]);
			if (!drawer) return;

			const mobileOnly = cfg[6];
			drawer.id = drawer.id || cfg[2];
			makeButton(drawer.querySelector(":scope [data-js-close]"), cfg[5]);

			if (handle) {
				if (handle.tagName === "A") {
					// cart link already has role="button"; add Space support and a count in its name
					makeButton(handle, null);
					updateCartLabel(handle);
					const count = handle.querySelector("[data-header-cart-count]");
					if (count) new MutationObserver(function () { updateCartLabel(handle); }).observe(count, { childList: true, characterData: true, subtree: true });
				} else {
					makeButton(handle, cfg[3]);
				}
				handle.setAttribute("aria-controls", drawer.id);
				handle.setAttribute("aria-haspopup", "dialog");
			}

			let wasOpen = drawer.classList.contains("opened");
			let opener = null;

			function sync() {
				const open = drawer.classList.contains("opened");
				const offCanvas = !mobileOnly || MOBILE.matches;

				// closed off-canvas drawers are out of view: take them out of the
				// accessibility tree and the tab order
				drawer.inert = offCanvas && !open;

				if (mobileOnly) {
					if (MOBILE.matches) {
						drawer.setAttribute("role", "dialog");
						drawer.setAttribute("aria-modal", "true");
						drawer.setAttribute("aria-label", cfg[4]);
					} else {
						drawer.removeAttribute("role");
						drawer.removeAttribute("aria-modal");
						drawer.removeAttribute("aria-label");
					}
				}

				if (handle) handle.setAttribute("aria-expanded", open ? "true" : "false");

				// remember what opened the drawer and give focus back to it on close;
				// menu + search also move focus in on open (the cart does that further up)
				if (offCanvas && open !== wasOpen) {
					if (open) {
						const active = document.activeElement;
						opener = active && active !== document.body && !drawer.contains(active) ? active : handle;
						if (mobileOnly && !drawer.contains(document.activeElement)) {
							const close = drawer.querySelector("[data-js-close]");
							const target = drawer.querySelector('input[type="search"]') || close;
							let tries = 0;
							(function attempt() {
								if (drawer.contains(document.activeElement)) return;
								if (target) target.focus({ preventScroll: true });
								if (document.activeElement !== target && ++tries < 12) setTimeout(attempt, 50);
							})();
						}
					} else if (drawer.contains(document.activeElement) || document.activeElement === document.body) {
						const back = opener && opener.isConnected && opener.getClientRects().length ? opener : handle;
						if (back) back.focus({ preventScroll: true });
					}
				}
				wasOpen = open;
			}

			new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ["class"] });
			MOBILE.addEventListener("change", sync);
			sync();
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();

// Desktop menu: hover vs keyboard / screen reader conflict
// The submenus open on mouseenter and close on mouseleave. With VoiceOver (or
// Loom / "mouse pointer follows VoiceOver cursor") the pointer jumps along with
// focus, so hover handlers fire on whatever it passes and open/close panels the
// user did not ask for. While the menu is being used by keyboard / screen
// reader, hover is ignored and the submenu toggle buttons alone open or close a
// panel. Real mouse use (a click, or continuous movement) turns hover back on.
(function () {
	const DESKTOP = window.matchMedia("(min-width: 949px)");
	const HOVER_TARGETS = ".has-first-submenu, .has-second-submenu, .sidebar__seconds, .sidebar__thirds";

	let keyboardMode = false;
	let lastPointerDown = 0;
	let lastFocusMove = 0;
	let moves = [];

	// focus that arrives without a click = keyboard or screen reader navigation
	document.addEventListener("focusin", function (e) {
		if (!(e.target instanceof Element) || !e.target.closest("main-sidebar")) return;
		lastFocusMove = Date.now();
		if (Date.now() - lastPointerDown > 400) keyboardMode = true;
	}, true);

	document.addEventListener("pointerdown", function (e) {
		if (e.pointerType === "mouse" && e.isTrusted) {
			lastPointerDown = Date.now();
			keyboardMode = false;
		}
	}, true);

	// a screen reader moves the pointer in single jumps; a person moving the
	// mouse produces a steady stream of events
	document.addEventListener("mousemove", function () {
		if (!keyboardMode) return;
		const now = Date.now();
		if (now - lastFocusMove < 600) return;
		moves.push(now);
		moves = moves.filter(function (t) { return now - t < 400; });
		if (moves.length >= 8) {
			keyboardMode = false;
			moves = [];
		}
	}, true);

	function blockHover(e) {
		if (!DESKTOP.matches || !keyboardMode) return;
		const target = e.target;
		if (!(target instanceof Element) || !target.matches(HOVER_TARGETS)) return;
		if (!target.closest("main-sidebar")) return;
		const active = document.activeElement;
		if (active && active.closest("main-sidebar")) e.stopPropagation();
	}

	// mouseenter/mouseleave don't bubble, but they do pass through the capture
	// phase, so stopping them here keeps the theme's hover handlers from running
	document.addEventListener("mouseenter", blockHover, true);
	document.addEventListener("mouseleave", blockHover, true);
})();
